export const ROUTE_BASE_CASE_STUDY = '/work'
export const ROUTE_BASE_ARTICLE = '/insights'
export const ROUTE_CATEGORY_ARTICLE = `${ROUTE_BASE_ARTICLE}/category`
export const ROUTE_BASE_SERVICES = '/services'
